import { z } from "zod";
import { EierBrukerAnnetEnum, TypeAnleggEnum } from "../reportEnums";

export const ZEierBrukerAnnetEnumShema = z.nativeEnum(EierBrukerAnnetEnum).nullable();

export const ZTypeAnleggEnumSchema = z.nativeEnum(TypeAnleggEnum).nullable();

export const ZLovverkTableRowSchema = z.object({
  lovverk: z.string(),
  utgave: z.string(),
});

export type ILovverkTableRow = z.infer<typeof ZLovverkTableRowSchema>;

export const ZElektroSamsvarserklaringEkomnettSchema = z.object({
  generellInfo: z.object({
    utarbeidetAv: z.string(),
    kontrollertAv: z.string(),
    godkjentAv: z.string(),
    dokumentNr: z.string(),
    revisjonsNr: z.string(),
  }),
  oppdragsgiver: z.object({
    navn: z.string(),
    oppdragsnummer: z.string(),
    kontaktperson: z.string(),
    adresse: z.string(),
    postboks: z.string(),
    postNr: z.string(),
    sted: z.string(),
    telefon: z.string(),
    email: z.string(),
    kundenummer: z.string(),
  }),
  anleggsadresse: z.object({
    navn: z.string(),
    adresse: z.string(),
    postNr: z.string(),
    sted: z.string(),
    husNr: z.string(),
    husNrBokstav: z.string(),
    boligMappeId: z.string(),
  }),
  kontaktperson: z.object({
    eierBrukerAnnet: ZEierBrukerAnnetEnumShema,
    navn: z.string(),
    telefon: z.string(),
    email: z.string(),
  }),
  ordreopplysninger: z.object({
    ordreNummer: z.string(),
    startDato: z.string(),
    avsluttetDato: z.string(),
  }),
  utarbeidetAv: z.object({
    navn: z.string(),
    kontaktPerson: z.string(),
    adresse: z.string(),
    postNr: z.string(),
    sted: z.string(),
    telefon: z.string(),
    email: z.string(),
    organisasjonsNr: z.string(),
    enaAutorisasjonsNr: z.string(),
  }),
  fravikFraAnvendteNormer: z.string(),
  anleggsbeskrivelse: z.object({
    typeAnlegg: ZTypeAnleggEnumSchema,
    utfoertIht: z.array(
      z.object({
        lovverk: z.string(),
        utgave: z.string(),
      }),
    ),
    arbeidsbeskrivelse: z.string(),
  }),
  generatedAt: z.string(),
  generatedBy: z.string(),
});

export type IElektroSamsvarserklaringEkomnettRapport = z.infer<typeof ZElektroSamsvarserklaringEkomnettSchema>;
